import { isSelfHostedDistribution } from "utils/distribution";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

const useAacFlags = () => {
  const { customAccessRoles: customAccessRolesLD } = useTypedFlags();
  const { customAccessRoles: customAccessRolesSelfHosted } = useSelfHostedFlags();

  return {
    customAccessRoles: isSelfHosted ? customAccessRolesSelfHosted : customAccessRolesLD,
    // Extension point for customAccessRolesV2
  };
};

export default useAacFlags;
